import React from 'react'
import './Rules.css'
import withLayout from '../../withLayout'

const Rules = () => (
  <div className='rules'>
    <h2>Reglas</h2>
    <p>Stadium ¡Todos juegan!</p>
    <p>¿Quién de tus amigos es el mejor en sus quinielas?, ¿el verdadero gurú?, ¿the one and the only?</p>
    <p>La idea de la quiniela es jugar para saber quien sabe mas y quien es el mejor para predecir jornada a jornada y también para el acumulado al final del torneo.</p>
    <ol>
      <li>La <b>Liga MX</b> será la base para jugar la quiniela, es decir, cada jornada de la <b>Liga MX</b> saldrá un formulario con los juegos correspondientes nacionales o internacionales.</li>
      <li>Tenemos dos opciones para jugar:<br /><b>Liga MX</b>, se juega cada semana con 9 partdos de la liga mexicana.<br /><b>Liga MX Plus</b>, se juega con 9 partidos de la liga mexicana como base y 9 partidos que pueden ser de ascenso MX, liga francesa, inglesa, italiana, alemana o española.</li>
      <li>El administrador del grupo elegirá la opción que prefiera al crear al grupo, una vez creado el grupo, no hay forma de cambiar la modalidad que se está jugando.</li>
      <li>Si se cancela un partido antes de empezar la jornada no cuenta ese partido en la suma parcial y final.</li>
      <li>Cada participante dentro de cada grupo, contestará sus predicciones durante la semana que se irán guardando para competir al inicio de la jornada, se pueden hacer los cambios que quieran hasta antes del arranque de la jornada.</li>
      <li>La quiniela empieza a jugar al silbatazo inicial del primer partido de la jornada. Después de eso, se cierra la posibilidad de subir o cambiar tus resultados.</li>
      <li>Si se cancelara el partido durante la jornada, no se tomará ese partido en cuenta.</li>
      <li>No olvidar que algunas veces hay jornadas dobles.</li>
      <li>Cada partido contará como un acierto, habrá una lista por jornada y una lista que vaya sumando el acumulado.</li>
      <li>Habrá dos sumatorias, una jornada a jornada y otra que va acumulando los resultados de todo el torneo.</li>
    </ol>
    <p>Cualquier comentario, sugerencia, inquietud, no dudes en contactarnos. ¡Diviértete!.</p>
  </div>
)

export default withLayout(Rules, null)
